/**
 * Created by anatoly on 27.05.26
 */

const LightningRushMarksView = cc.Node.extend({
    avoidView: "LightningRushMarksView",

    ctor: function () {
        this._super();

        const styles = cleverapps.styles.LightningRushMarksView;

        this.mission = Game.currentGame.lightingRushMission;
        this.setLocalZOrder(10);

        this.setAnchorPoint(0.5, 0.5);

        this.background = this.createBackground();

        this.setAlignment(this.getStackedPosition());

        this.icon = this.createIcon();
        this.text = this.createText();

        cleverapps.eventBus.on("collectMark", this.createListener(this.runCollectAnimation.bind(this)), this);

        cleverapps.tooltipManager.create(this, {
            text: Messages.get("CloversTooltip"),
            location: cleverapps.config.name === "runes" ? cleverapps.UI.Tooltip.LOCATION_ABOVE : cleverapps.UI.Tooltip.LOCATION_BELOW,
            control: "lightningRushMarksViewTooltip",
            interactiveScale: cleverapps.config.type !== "match3"
        });

        cleverapps.aims.registerTarget(`mission_reward${this.mission.type}`, this.icon, {
            flyingUnderShadow: true,
            controls: ["rewardElementLightningRushMarks"]
        });

        this.setContentSize2(styles);
        this.background.setContentSize2(styles);

        this.icon.setAlignment(styles.icon);
        this.text.setAlignment(styles.text);

        this.onResize();
    },

    onResize: function () {
        if (!Game.currentGame) {
            return;
        }

        const styles = cleverapps.styles.LightningRushMarksView;

        this.setScale(styles.scale[cleverapps.resolution.mode]);

        this.setAlignment(this.getStackedPosition());
    },

    getStackedPosition: function () {
        const styles = cleverapps.styles.LightningRushMarksView;
        if (!Game.currentGame.kingsCupMission || !KingsCupMarksView.isAvailable()) {
            return styles.position;
        }

        return styles.position.map((pos) => ({
            x: pos.x,
            y: { align: pos.y.align, dy: (pos.y.dy || 0) + styles.stackOffsetY }
        }));
    },

    createBackground: function () {
        const background = cleverapps.UI.createScale9Sprite(bundles.reward_element.frames.reward_element_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setAnchorPoint(0, 0);
        this.addChild(background);
        return background;
    },

    createIcon: function () {
        const styles = cleverapps.styles.LightningRushMarksView;

        const icon = new cc.Sprite(this.mission.getIcon());
        this.addChild(icon);
        cleverapps.UI.fitToBox(icon, styles.icon);
        icon.baseScale = icon.scale;

        return icon;
    },

    createText: function () {
        const styles = cleverapps.styles.LightningRushMarksView;

        const text = this.text = cleverapps.UI.generateImageText(
            this.getTextString(),
            cleverapps.styles.FONTS.LIGHTNING_RUSH_MARKS_TEXT
        );
        this.addChild(text);
        text.setAlignment(styles.text);

        return text;
    },

    getTextString: function () {
        return Game.currentGame.rewards.lightningRush || 0;
    },

    getSparksColor: function () {
        return "yellow";
    },

    runCollectAnimation: function () {
        this.stopAllActions();

        const styles = cleverapps.styles.LightningRushMarksView;

        this.icon.runAction(new cc.Sequence(
            new cc.CallFunc(() => {
                if (!["board", "blocks"].includes(cleverapps.config.type)) {
                    return;
                }

                const sparks = new cleverapps.Spine(bundles.animations_library.jsons.sparks_json);
                sparks.setSkin(this.getSparksColor());
                sparks.setAnimation(0, "single", false);
                sparks.setCompleteListenerRemove();

                this.addChild(sparks, 0);
                sparks.setAlignment(this.icon.getPositionX() + styles.sparks.x, this.icon.getPositionY() + styles.sparks.y);
            }),

            cleverapps.effects.fireAction("tournament.element.collected"),
            new cc.ScaleTo(0.15, this.icon.baseScale * 1.1),
            new cc.CallFunc(() => {
                this.text.setString(this.getTextString());
            }),
            new cc.ScaleTo(0.15, this.icon.baseScale)
        ));
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LIGHTNING_RUSH_MARKS_TEXT: {
        name: "default",
        size: 40
    }
});

LightningRushMarksView.isAvailable = function () {
    return !cleverapps.styles.LightningRushMarksView.disabled;
};

cleverapps.styles.LightningRushMarksView = {
    width: 150,
    height: 61,

    scale: [1, 1, 1],

    stackOffsetY: -80,

    position: [
        {
            x: { align: "left", dx: 40 },
            y: { align: "top", dy: -150 }
        },
        {
            x: { align: "left", dx: 236 },
            y: { align: "top", dy: -150 }
        },
        {
            x: { align: "left", dx: 250 },
            y: { align: "top", dy: -150 }
        }
    ],

    icon: {
        x: { align: "center" },
        y: { align: "center" },

        width: 100,
        height: 100
    },

    text: {
        x: { align: "center", dx: 20 },
        y: { align: "center" }
    },

    sparks: {
        x: 0,
        y: 0
    }
};
